import { createApp } from "vue";
import App from "./App.vue";
import vuetifyConf from "./plugins/vuetify";
import { createVuetify } from "vuetify";
import { VPullToRefresh } from "vuetify/labs/VPullToRefresh";

// import { loadFonts } from "./plugins/webfontloader";

import store from "./store/index.js";
import router from "./router.js";
import Datepicker from "@vuepic/vue-datepicker";
import VueSweetalert2 from "vue-sweetalert2";
import "@vuepic/vue-datepicker/dist/main.css";
import AlertDialog from "./components/AlertDialog.vue";
// import VueApexCharts from "vue3-apexcharts";
import { createVueI18nAdapter } from "vuetify/locale/adapters/vue-i18n";
import { useI18n } from "vue-i18n";
import i18n from "./i18n";
import ChartDataLabels from "chartjs-plugin-datalabels";
import PageTitle from "./components/PageTitle.vue";
import InfoBanner from "./components/InfoBanner.vue";
// import PloralAR from "./i18n/plural_ar";
import {
  Chart as ChartJS,
  PointElement,
  LineElement,
  Filler,
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
} from "chart.js";

ChartJS.register(
  BarElement,
  ChartDataLabels,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler
);
import AppTable from "./components/TheAppTable.vue";
// eslint-disable-next-line
import styles from "./scss/main.scss";

import PrimeVue from "primevue/config";
import "./assets/main.css";
import "./assets/styles.css";
import simplebar from 'simplebar-vue';
import 'simplebar-vue/dist/simplebar.min.css';
import ToastService from 'primevue/toastservice';
// loadFonts();

const vuetify = createVuetify({
  locale: {
    adapter: createVueI18nAdapter({ i18n, useI18n }),
  },
  components: {
    VPullToRefresh,
  },
  ...vuetifyConf,
});

ChartJS.register(
  BarElement,
  ChartDataLabels,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler
)

const app = createApp(App);
app.use(store);
app.use(router);
app.use(i18n);
app.use(vuetify);
app.use(VueSweetalert2);

app.use(PrimeVue, {
  theme: "none",
  options: {
    darkModeSelector: false,
  },
});
app.use(ToastService);

app.mixin({
  methods: {
    getArabicPluralKey: function (localString, count) {
      let key;
      if (count == 0) {
        key = "zero";
      } else if (count == 1) {
        key = "one";
      } else if (count == 2) {
        key = "two";
      } else if (count > 2 && count < 11) {
        key = "few";
      } else {
        key = "many";
      }
      return localString + "." + key;
    },
    userHasPermisson: function (userPermissionsList, targetPermissions) {
      return userPermissionsList.includes(targetPermissions);
    },
  },
});
app.component("DatePicker", Datepicker);
// app.component("ApexChart", VueApexCharts);
app.component("alert-dialog", AlertDialog);
app.component("app-table", AppTable);
app.component("page-title", PageTitle);
app.component("info-banner", InfoBanner);
app.component("simple-bar", simplebar);
app.mount("#app");
